// UI texts: inventory
export default {
  title: 'Inventory',
  storage: 'Storage',
  /** 29. 9. 2026: the Storage meter's tip. */
  // 23. 10. 2026 (owner, a player's feedback): what takes room, said plainly, and what is in it now.
  storageTip: "Every unit of a resource takes 1 room, and so does every piece of gear kept here. Scrap, Relic Shards, Blueprints and other specials take none. What doesn't fit is left behind when you take loot.",
  /** 23. 10. 2026 (owner, pilot report): the same once Tobias is at camp: he buys what doesn't fit. */
  storageTipTobias: "Every unit of a resource takes 1 room, and so does every piece of gear kept here. Scrap, Relic Shards, Blueprints and other specials take none. Resources that don't fit when you take loot, Tobias buys for a little Scrap; supplies that don't fit are left behind.",
  storageNow: 'Now: {gear} gear, {res} resources.',
  carried: 'Carried',
  load: 'Load',
  tabs: { gear: 'Gear', resources: 'Resources', consumables: 'Consumables', special: 'Special' },
  /** 4. 10. 2026 (package 3, I): Blueprints in Storage, used to learn a recipe. */
  blueprints: {
    title: 'Blueprints',
    sub: 'Use one to learn a recipe. You keep one of the items it offers.',
    from: 'Found in {zone}',
    fromTrader: 'Any item',
    use: 'Use',
    choose: 'Choose one recipe to learn',
    chooseSub: '{rarity} recipe: you can craft it up to {rarity}, on your tier (T{tier}).',
    learn: 'Learn',
    known: 'You know it up to {rarity}',
    vsWorn: '{d} vs worn',
    emptySlot: 'empty slot',
    nothing: 'You know everything this Blueprint teaches. It turns into materials and Scrap:',
    takeApart: 'Take it apart',
    learned: 'Recipe learned: {rarity} {name}. Craft it in the Workshop.',
    salvaged: 'The Blueprint became materials and Scrap.',
    toWorkshop: 'Open the Workshop',
  },
  newInTab: '{n} new in this tab',
  /** 4. 10. 2026 (package 3, 7.g): the star on a Pristine item's card. */
  pristineMark: 'Pristine: one affix past the best roll',
  all: 'All',
  sort: 'PWR',
  sortAria: 'Sort by {by}, {dir}',
  count: '{n} items · {dir}',
  countOne: '1 item · {dir}',
  sortBy: { power: 'Power', rarity: 'Rarity', tier: 'Tier', newest: 'Newest' },
  sortShort: { power: 'PWR', rarity: 'RAR', tier: 'TIER', newest: 'NEW' },
  filter: { slot: 'Slot', anySlot: 'All', set: 'Set', anySet: 'All', tier: 'Tier', anyTier: 'All', sort: 'Sort' },
  lock: {
    lock: 'Lock',
    locked: 'Locked',
    lockHint: "Lock it. Locked items can't be dismantled or stolen.",
    unlockHint: 'Unlock it',
    noDismantle: 'Locked. Unlock it to dismantle.',
  },
  auto: {
    title: 'Auto-dismantle',
    body: 'New gear that matches turns into scrap when you claim a run. It only touches loot from that run.',
    enabled: 'Dismantle new loot automatically',
    /** 9. 10. 2026 (owner): a highest tier per rarity. */
    perRarity: 'Up to which tier',
    off: 'Off',
    rowAria: '{rarity}: up to which tier',
    upTo: '{rarity} up to T{n}',
    summary: 'Dismantles {list}.',
    nothing: 'Pick a tier for at least one rarity.',
    never: 'Locked items and Legendary items are never dismantled.',
    save: 'Save',
    buttonOn: 'Auto-dismantle: on',
    buttonOff: 'Auto-dismantle: off',
  },
  /** Krug 5 (K7.1): dismantle many items at once. */
  bulk: {
    button: 'Dismantle…',
    title: 'Dismantle gear',
    rarity: 'Rarity',
    tier: 'Tier',
    upTo: 'Up to T{n}',
    allTiers: 'All tiers',
    slot: 'Slot',
    allSlots: 'All slots',
    weaker: 'Only items weaker than what I wear',
    keepBest: 'Keep the best copy of each item',
    preview: 'What goes',
    count: '{n} items',
    countOne: '1 item',
    tapHint: 'Tap an item to leave it out. Lock an item in its details to keep it out of every dismantle.',
    none: 'Nothing matches these filters.',
    exclude: 'Leave {name} out',
    include: 'Put {name} back',
    gain: 'What you get',
    /** 23. 10. 2026 (owner, a player's feedback): the materials go to Storage too. */
    storageAfter: 'Storage after: {to} / {cap}',
    storageOver: 'The materials go to Storage too and take it over its limit: runs leave loot behind until you make room.',
    kept: {
      locked: '{n} locked items kept',
      lockedOne: '1 locked item kept',
      upgrading: '{n} items in the Workshop kept',
      upgradingOne: '1 item in the Workshop kept',
      account_bound: '{n} Relic Forge items kept',
      account_boundOne: '1 Relic Forge item kept',
      legendary: '{n} Legendary items kept',
      legendaryOne: '1 Legendary item kept',
      away: '{n} items in the pack kept while your survivor is out',
      awayOne: '1 item in the pack kept while your survivor is out',
      equipped: '{n} worn items kept',
      equippedOne: '1 worn item kept',
      not_found: '{n} items are gone',
      not_foundOne: '1 item is gone',
    },
    confirmRare: 'I understand Rare and Epic items will be destroyed',
    go: 'Dismantle {n} items',
    goOne: 'Dismantle 1 item',
    done: 'Dismantled {n} items: {gain}',
    doneOne: 'Dismantled 1 item: {gain}',
    skipped: '{n} kept',
  },
  best: {
    button: 'Equip best',
    title: 'Equip best gear',
    none: 'You are already wearing your best gear.',
    error: 'Could not work out the best gear right now.',
    replaces: 'instead of {name}',
    emptySlot: 'empty slot',
    takeOff: 'Take off {name}',
    overloaded: 'This gear makes you Overloaded: {effects}.',
    confirm: 'Equip',
    /** 28. 10. 2026 (owner, players' feedback): the suggested weapon burns Ammo or Fuel and Storage and the pack have none. */
    noFeed: 'No {what} left: this weapon does {pct}% less damage until you have some.',
  },
  highLow: 'high → low',
  lowHigh: 'low → high',
  worn: 'WORN',
  inPack: 'PACK',
  pwr: 'PWR {n}',
  /** 7. 10. 2026: a broken item on a Workshop repair bench. */
  inRepair: 'In repair',
  /** 30. 9. 2026: PWR only compares gear of the same tier. */
  pwrTip: "PWR compares gear of the same tier. It's measured on a level {t1} survivor for T1, level {t2} for T2, level {t3} for T3 and level {t4} for T4. To compare across tiers, look at your Power.",
  /** 6. 10. 2026 (owner): PWR counts duels; the line under it when an item also does what a duel never shows. */
  situational: {
    note: 'PWR counts duels. This item also shines {where}.',
    ambush: 'in ambushes',
    against: 'against {who}',
    in: 'in {where}',
    raid: 'in clan raids',
    and: ' and ',
    foe: {
      infected: 'Infected',
      raider: 'Raiders',
      mutant: 'Mutants',
      drone: 'drones',
      armored: 'armored targets',
      horde: 'the Horde',
      boss: 'bosses',
      survivor: 'other survivors',
      npc: 'NPCs',
      stronger: 'stronger enemies',
    },
    zone: {
      forest: 'Calder Woods',
      gas_station: 'Route 9 Gas & Go',
      downtown: 'Downtown',
      hospital: 'Mercy General',
      factory: 'Calder Steelworks',
      military_base: 'Fort Halden',
      mountains: 'Pine Ridge',
      wasteland: 'The Burn',
      secret_bunker: 'Civil Defense Bunker',
      underground_lab: 'Halcyon Lab',
      survivor_vault: 'The Vault',
      open_pvp: 'open PvP zones',
    },
  },
  /** Krug 5 (K4.16): the card line for gear without combat Power ("Loot +3%", "Cap 25"). */
  effectShort: {
    capacity: 'Cap',
    loot: 'Loot',
    xp: 'XP',
    expeditionTime: 'Speed',
    discovery: 'Find',
    craftSpeed: 'Craft',
    healing: 'Heal',
    stealth: 'Stealth',
    detect: 'Detect',
    escape: 'Escape',
    luck: 'Luck',
  },
  carriedSection: {
    title: 'Carried',
    sub: 'Still in the pack. Raiders can take it until it is in Storage.',
    out: 'The pack is out there with your survivor.',
    unload: 'Unload to storage',
    unloaded: 'Unloaded into Storage',
    full: 'Storage is full. Upgrade it at camp or make room first.',
  },
  empty: {
    gear: { title: 'No gear yet', body: 'Expeditions bring gear back. The Workshop makes it from scrap.' },
    resources: { title: 'Storage is empty', body: 'Metal, cloth and scrap come back from every expedition.' },
    consumables: { title: 'No supplies', body: 'Bandages and medkits turn up in Mercy General. You can also make them at the bench.' },
    special: { title: 'Nothing special yet', body: 'Old maps, lab clues and Relic Shards hide in the dangerous zones; Blueprints turn up everywhere now and then.' },
    filter: { title: 'Nothing {rarity} here', body: 'Try another rarity.' },
    showAll: 'Show all',
    toMap: 'Go scavenging',
    toWorkshop: 'Open workshop',
  },
  /** Package 4, part E: an item taken in a fight. */
  custody: {
    heldShort: 'Taken · {t} left',
    coolShort: 'Cooling · {t}',
    held: '{name} took it in a fight. It is bound to you: win it back within {t} or it breaks.',
    cool: 'Taken from {name} in a fight. You can wear or dismantle it in {t}; until then they can win it back.',
    holdBound: 'Taken from {name} in a fight. It is bound to them: you only hold it, and it breaks in {t} unless they win it back.',
    revenge: 'Revenge',
  },
  detail: {
    close: 'Close',
    /** 28. 10. 2026: an item opened from a report's log or the order sheet that is no longer there (dismantled, sold, taken). */
    gone: 'That item is no longer in your gear.',
    ilvl: 'iLvl {n}',
    requiresLevel: 'Requires Lv {n}',
    levelTooLow: 'Your survivor can wear this from level {n}. Keep it, or dismantle it.',
    // 23. 10. 2026 (BACKLOG #55): one tier up, worn as the top of the survivor's tier until its level.
    growsIn: 'Grows in at Lv {n}',
    growsTip: 'Worn now as a top T{t} item with the same rolls; its full stats from level {n}.',
    growsNote: 'Worn as a top T{t} item until level {n} (the same rolls): PWR {now} now, {full} from level {n}.',
    tier: 'T{n}',
    passive: 'Passive',
    bonuses: 'Bonuses',
    /** Package 4, part N: a bonus's two sentences end with a link to its row in the Guide. */
    inGuide: 'In the Guide',
    durability: 'Durability',
    /** 7. 10. 2026 (owner): a broken item keeps 75% of its stats, its perk and its set piece. */
    broken: 'Broken: −{pct}% stats until it is repaired. Its perk still works.',
    inRepair: 'In the Workshop: whole again in {time}. It cannot be worn until then.',
    repairBroken: 'Repair ({time})',
    /** 28. 10. 2026 (player report): what the player has next to what it takes (no Shards part when it takes none). */
    repairBrokenShards: 'Repair ({time} · {n} of your {have} Relic Shards)',
    repairBrokenCost: 'and {what}',
    repairBrokenNote: 'A job on one Workshop bench. The item comes off until it is done; Equip Best can fill the slot meanwhile.',
    repair: 'Repair',
    repairHave: 'you have {n}',
    repairShort: 'Not enough: {what}',
    repairKit: 'Use Repair Kit',
    repairKitSub: '+{add} durability · {n} left',
    precisionKit: 'Use Precision Repair Kit',
    repairOut: 'Equipped gear is out there. Repair it when your survivor is back.',
    vsEquipped: 'VS equipped',
    emptySlot: 'Empty slot',
    wearing: 'You are wearing this.',
    power: 'Power',
    /** 30. 9. 2026: the survivor's Power with the item on, and the item's PWR (same tier only). */
    yourPower: 'Your Power',
    itemPwr: 'Item PWR',
    durabilityRow: 'Durability',
    equip: 'Equip',
    unequip: 'Unequip',
    equipped: '{name} equipped',
    unequipped: '{name} back in Storage',
    dismantle: 'Dismantle',
    /** Package 4, part E (owner's text): a bound item can be taken in a fight, then won back within 24 h or it breaks. */
    accountBound: "Bound to you: it can never be traded. If it's taken in a fight, win it back within 24 h or it breaks.",
    wornBound: "{name} is bound to you: it can never be traded. If it's taken in a fight, win it back within 24 h or it breaks.",
    dismantleWorn: 'Unequip it before dismantling.',
    unequipFirst: 'Unequip first',
    confirmTitle: 'Dismantle {name}?',
    confirmBody: 'You get {what}. This cannot be undone.',
    onExpedition: 'Your survivor is out there wearing their gear. Change it when they are back.',
    inPack: 'Still in the pack. It moves to Storage when you unload.',
    slotLocked: 'The {slot} slot opens in a later update. You can keep this or dismantle it.',
    loadChange: 'Load {from}% → {to}%',
    /** 6. 10. 2026 (owner): the parts of a main stat with an affix on it, and that affix in the lists. */
    mainParts: '{base} base + {affix} affix',
    mainAffix: '{stat} affix',
    loadBecomes: 'becomes {state}',
    crafted: 'Made at your bench',
    /** 7. 10. 2026 (owner): the average of the affixes' rolls; every affix shows its own. */
    roll: 'Avg roll {n}%',
    rollTip: 'The average of its affixes’ rolls: how close each rolled to the best it could be on this item',
    affixes: 'Affixes',
    affixRoll: '{n}%',
    affixWhole: '{v} of {lo}–{hi}',
    affixRollTip: 'Rolled {n}% of its range on this item',
    /** 9. 10. 2026 (owner): an affix at 90% of its range or more. */
    affixTop: 'Top roll',
    affixTopTip: 'In the top {n}% of its range: about 1 affix in {k} rolls this high',
    builtIn: 'Built-in',
    builtInTip: 'Part of this item itself, not an affix: it does not roll',
    /** 4. 10. 2026 (package 3, 7.g): one affix rolled past the catalog's best. */
    pristine: 'Pristine: {affix}, {m}× the best roll this item can have',
    weapon: 'Weapon',
    perks: 'Perks: {what}',
  },
  perk: {
    signature: 'Signature perk',
    legendary: 'Legendary perk',
    epic: 'Epic: {desc}',
    old: 'Perk',
    fromRare: 'From Rare on: {name}, {desc}',
    /** Package 4, part N. */
    counterOpen: 'What counters it?',
    counter: 'Countered by: {what}',
  },
  /** 1. 10. 2026 (C4): the tier upgrade. */
  /** 4. 10. 2026 (package 3, H): Rework, one rarity up. */
  rework: {
    title: 'Rework',
    titleTo: 'Rework to {rarity}',
    newAffix: '+1 random affix',
    keeps: 'Keeps its +{n}, its rolls and its tier. New limit: +{max}.',
    perk: 'Perk',
    donors: 'Donors',
    donorsPick: 'Pick {n}',
    donorsHint: 'Same slot, {rarity}, T{tier} or higher. They are used up.',
    donorPlus: 'This one is +{n}; its upgrades are lost with it.',
    noDonors: '{text}',
    showAll: 'Show upgraded items too',
    cost: 'Cost',
    time: '~{time} in the Workshop',
    button: 'Rework to {rarity}',
    pickDonors: 'Pick {n} donors first.',
    pickDonor: 'Pick a donor first.',
    pwrAbout: 'PWR ~{n}',
    started: 'Rework started in the Workshop',
  },
  /** 11. 10. 2026 (BACKLOG #36): Recalibrate (the item detail and the Workshop tab). */
  recalibrate: {
    title: 'Recalibrate',
    uses: 'Recalibrated {n}×',
    intro: 'Pick one affix. It becomes a new random affix, and from then on it is the only affix of this item that can change.',
    introLocked: 'Only the Recalibrated affix of this item can change.',
    mark: 'Recalibrated',
    markTip: 'Recalibrated. Each item can be recalibrated once.',
    /** 23. 10. 2026 (owner): once an item. */
    done: 'This item was recalibrated: each item can be recalibrated once.',
    pristine: 'Pristine: stays',
    /** 28. 10. 2026 (owner): never the old kind again; an affix with no other kind left stays. */
    noNew: 'Same kind, new roll',
    pick: 'Pick the affix to change.',
    changes: 'Changes',
    random: 'a new random affix',
    nonCombat: 'The new one is again an affix outside the fight (loot, speed, pack room and the like).',
    picksLost: 'Its milestone picks are lost with it.',
    next: 'Each item can be recalibrated once: this is its only Recalibrate.',
    refund: 'Dismantled, it gives back {p}% of the materials and Scrap, never the Relic Shards.',
    button: 'Recalibrate…',
    confirmTitle: 'Recalibrate {affix}?',
    confirmBody: 'It becomes a new random affix of this slot: a different kind, never one the item already has (the same kind with a new roll only when it can be nothing else).',
    lost: 'The old affix is lost.',
    confirm: 'Recalibrate',
    result: 'New affix: {affix}',
    resultRoll: '{n}% of its range',
    away: 'Wait until your survivor is back to change a worn item.',
  },
  tierUp: {
    title: 'Tier upgrade',
    button: 'Upgrade to T{n}',
    keeps: 'Keeps its rarity, perk, rolls and +{n}. Item level {lv}.',
    top: 'T4: the top tier.',
  },
  upgrade: {
    title: 'Upgrade',
    level: '+{n}/{max}',
    bar: 'Upgrade +{n} of +{max}',
    button: 'Upgrade to +{n}',
    busy: 'Upgrading in the Workshop…',
    maxed: 'Fully upgraded: +{max} is the most for this rarity.',
    milestone: 'At +{n} one of its affixes gets stronger.',
    allStats: '+{pct}% to every affix per level',
    /** Krug 5 (K4.12, K4.14). */
    pwr: 'PWR',
    perLevel: '+{pct}% {stat} per level',
    /** 30. 9. 2026: armor grows its affixes too; what one level adds; the survivor's Power. */
    perLevelAffixes: '+{pct}% {stat} and every affix per level',
    gain: '+{pct}% {stat}',
    gainAffixes: '+{pct}% {stat} and affixes',
    yourPower: 'your Power {pct}',
    milestoneAt: 'At +{n}: boost one affix',
    milestoneNone: 'At +{n}: no affix to boost',
    pickTitle: 'At +{n}: pick an affix to boost',
    /** 5. 10. 2026: the pick of an upgrade in the queue. */
    milestoneChosen: '+{n} milestone: {stat} {from} → {to}',
    pickFirst: 'Pick an affix first.',
    /** 6. 10. 2026 (owner): how milestone picks work (rule B), and how often an affix was picked. */
    pickNote: 'First pick: the top of the affix’s range or +{pct}% of its rolled value, whichever is more. Each further pick: +{pct}% of its rolled value, up to {cap}× the top; in all never less than +{pct}% a pick. Picks are for good and stay through Rework and tier upgrades.',
    /** 6. 10. 2026 (owner): an attribute pick that does not change the fight (attributes count whole). */
    countsInFights: '(counts as {n} in fights)',
    picked: 'picked {n}×',
    /** 6. 10. 2026 (owner): an affix on the main stat in the milestone pick: "+15 Capacity affix → +16.5 (total 161.9 → 163.4)". */
    affixWord: 'affix',
    totalChange: '(total {from} → {to})',
    atMax: 'At max (+{n}):',
    left: 'left',
    wsAfter: 'Workshop {ws} needed after +{n}',
    showDetails: 'Show details',
    hideDetails: 'Hide details',
    workshop: 'Workshop {ws} needed for +{n}',
    short: 'Not enough: {what}',
    inPack: 'Unpack it into Storage first.',
  },
  weaponRule: {
    oneHanded: 'One-handed: +{i}% initiative, +{e}% escape',
    meleeTwoHanded: 'Two-handed: ignores {d}% of the target’s defense, −{e}% escape',
    rangedTwoHanded: 'Two-handed: −{i}% initiative, −{e}% escape',
    ranged: 'Ranged: fires one shot before the first melee round ({d}% damage, never a critical hit unless from an ambush)',
    /** 7. 10. 2026 (owner): Ammo per shot. */
    ammo: 'Uses 1 Ammo per shot; once it runs out, −30% damage',
    fuel: 'Uses 1 Fuel per fight; without it −30% damage',
    /** 5. 10. 2026: Iron Discipline. */
    ammoSurvivors: 'Uses 1 Ammo per shot against survivors, none against NPCs; once it runs out, −30% damage',
  },
  set: {
    title: '{name} set',
    countAria: '{n} of {max} pieces equipped',
    preview: 'with this: {n}',
    active: '{n} pieces: active',
    inactive: '{n} pieces: not active yet',
    showPieces: 'Show the {name} pieces',
  },
  slot: {
    weapon: 'Weapon',
    helmet: 'Helmet',
    body: 'Body armor',
    pants: 'Pants',
    boots: 'Boots',
    backpack: 'Backpack',
    gloves: 'Gloves',
    accessory: 'Trinket',
  },
  weaponClass: {
    melee_1h: 'One-handed melee',
    melee_2h: 'Two-handed melee',
    ranged_1h: 'One-handed ranged',
    ranged_2h: 'Two-handed ranged',
  },
  loud: 'Loud',
  stat: {
    damage: 'Damage',
    armor: 'Defense',
    hp: 'Max HP',
    str: 'STR',
    agi: 'AGI',
    int: 'INT',
    vit: 'VIT',
    per: 'PER',
    capacity: 'Capacity',
    accuracy: 'Accuracy',
    crit: 'Crit chance',
    escape: 'Escape chance',
    loot: 'Loot',
    stealth: 'Stealth',
    craftSpeed: 'Crafting speed',
    xp: 'XP gain',
    expeditionTime: 'Faster expeditions',
    healing: 'Healing',
    discovery: 'Discovery',
    detect: 'Detection',
    vsInfected: 'vs Infected',
    vsRaider: 'vs Raiders',
    vsMutant: 'vs Mutants',
    vsDrone: 'vs Drones',
    vsSurvivor: 'vs Survivors',
    dodge: 'Dodge',
    meleeResist: 'Less melee damage',
    rangedResist: 'Less ranged damage',
    luck: 'Luck',
    damagePct: 'Damage',
    ambush: 'Ambush damage',
    encounter: 'Fewer encounters',
    durability: 'Max durability',
  },
  statShort: {
    damage: 'DMG',
    armor: 'DEF',
    hp: 'HP',
    str: 'STR',
    agi: 'AGI',
    int: 'INT',
    vit: 'VIT',
    per: 'PER',
    capacity: 'CAP',
    accuracy: 'ACC',
    crit: 'CRIT',
    escape: 'ESC',
    loot: 'LOOT',
    stealth: 'STEALTH',
    craftSpeed: 'CRAFT',
    xp: 'XP',
    expeditionTime: 'TIME',
    healing: 'HEAL',
    discovery: 'FIND',
    detect: 'DETECT',
    vsInfected: 'VS INF',
    vsRaider: 'VS RAID',
    vsMutant: 'VS MUT',
    vsDrone: 'VS DRONE',
    vsSurvivor: 'VS PVP',
    dodge: 'DODGE',
    meleeResist: 'MELEE RES',
    rangedResist: 'RANGED RES',
    luck: 'LUCK',
    damagePct: 'DMG',
    ambush: 'AMBUSH',
    encounter: 'FEWER ENC',
    durability: 'MAX DUR',
  },
  stack: {
    category: { resource: 'Resource', consumable: 'Consumable', special: 'Special' },
    inStorage: 'In storage',
    carried: 'Carried',
    heal: 'Use · heal {n} HP',
    healed: 'Healed {n} HP',
    fullHp: 'Already at full HP',
    outThere: 'Your survivor is out there. They use these on their own.',
    notBack: 'Your survivor is not back at camp yet. Open the report first.',
    none: 'None in Storage.',
    read: 'Read the map',
    clues: 'Piece the clues together',
    fragments: 'Assemble the fragments',
    progress: '{have}/{need} collected',
    need: 'You need {n} to find the way.',
    /** Krug 5 (K12.11): meals. */
    cookMore: 'Cook more',
    leadsTo: 'Leads to',
    unknown: '? ? ?',
    hint: {
      meal: 'A meal. Pick it on the order sheet: one is eaten as the run leaves.',
      resource: 'Used for crafting, repairs and camp upgrades.',
      packed: 'Packed on the Prepare screen before an expedition.',
      repair_kit: 'Open a damaged item and use the kit from its detail.',
      blueprint: 'Unlocks Epic recipes at Workshop level 4.',
    },
    toWorkshop: 'Open workshop',
    toMap: 'Plan an expedition',
    discard: {
      open: 'Discard',
      title: 'Throw away',
      allBut: 'All but {n}',
      all: 'All',
      confirm: 'Discard {n}',
      done: 'Threw away {n} {name}',
      keep: '{n} stay in Storage',
    },
  },
  reveal: {
    first: 'First to find it',
    known: 'Already on the map',
    firstBody: 'Nobody had found it before you. It is on everyone’s map now, with your name on it.',
    knownBody: 'Someone got there first. The map still led to a cache: {what}.',
    cacheWhat: '40 scrap, 10 electronics and a medkit',
    openMap: 'Open the map',
    story: 'See the story',
    done: 'Done',
  },
} as const;
